<template>
  <main class="content">
    <!-- content -->
    <section class="intro">
      <div class='container'>
        <div class="intro__wrapper">
          <div class="intro__upline">
            <div class="intro__column-left intro-text">
              <h1 class="intro-text__title">
                ВЫИГРАЙТЕ СВОЕ ДЕЛО БЕЗ ОБРАЩЕНИЯ К ЮРИСТАМ
              </h1>
              <p class="intro-text__subtitle">
                Хочешь сделать хорошо? Сделай сам! Всего за 299 рублей
              </p>
            </div>
            <div class="intro__column-right intro-video">
              <iframe src="https://www.youtube.com/embed/oPNO94w-86Q"></iframe>
            </div>
          </div>
          <div class="intro__item item-intro" data-da="win__wapper,0,767">
            <div class="item-intro__column">
              <div class="item-intro__img">
                <svg class="item-intro__svg">
                  <use xlink:href="#1"></use>
                </svg>
              </div>
              <p class="item-intro__text">
                Получаете комплект необходимых документов чтобы выиграть свое дело. Готовите их по нашим
                шаблонам или доверяете подготовку нам.
              </p>
            </div>
            <div class="item-intro__column">
              <div class="item-intro__img">
                <svg class="item-intro__svg">
                  <use xlink:href="#2"></use>
                </svg>
              </div>
              <p class="item-intro__text">
                У вас будет чёткая инструкция действий.Идете с этими документами в суд или решаете в досудебном
                порядке
              </p>
            </div>
            <div class="item-intro__column">
              <div class="item-intro__img">
                <svg class="item-intro__svg">
                  <use xlink:href="#3"></use>
                </svg>
              </div>
              <p class="item-intro__text">
                Выигрываете дело. Без рисков и затрат на юристов
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="win">
      <div class='container'>
        <div class="win__wapper wrapper-win">
          <h2 class="win__title">
            Как выигрываются дела
          </h2>
          <div class="win__box box-win">
            <div class="win__items">
              <div class="win__card">
                <span class="win__items-number"><span>1</span></span>
                <p class="win__items-text">
                  Главные аргументы, позволяющие выиграть дело – доказательства. Доказательства - это документы, которые Вы подаете в суд или используете для досудебного решения вопроса – на их основании будет выноситься решение. Да! Это юридически грамотные документы, а не слова.
                </p>
              </div>

            </div>
            <div class="win__items">
              <div class="win__card">
                <span class="win__items-number"><span>2</span></span>
                <p class="win__items-text">
                  Вам не нужно быть юристом и разбираться во всем. Вы научитесь разбираться в своем конкретном вопросе благодаря шаблонам, образцам, памяткам и понятным инструкциям. Вы разберетесь с решением своего вопроса максимум за 2 часа.
                </p>
              </div>
            </div>
            <div class="win__items">
              <div class="win__card">
                <span class="win__items-number"><span>3</span></span>
                <p class="win__items-text">
                  Наши юристы уже все сделали за Вас. Вам остается потратить немного времени, заполнить шаблоны конкретно по своей ситуации и выиграть свое дело!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="accordion">
      <div class='container'>
        <div class="accordion__wrapper">
          <h1 class="accordion__title">
            Выбери свою ситуацию
          </h1>
          <div class="accordion__box box-accordion">
            <div class="accordion__item item-accordion" v-for="group in groups" :key="group.id">
              <h1 class="item-accordion__header">{{group.name}}</h1>
              <ul class="item-accordion__body">
                <li class="item-accordion__content" v-for="service in services" :key="service.id" v-if="parseInt(service.cf[341]) === group.id">
                  <span class="item-accordion__number">{{service.cf[342]}}</span>
                  <span class="item-accordion__text">{{service.name}}</span>
                  <router-link :to="'/services/' + service.id">
                    <picture>
                      <source srcset="/static/img/accordeon/link.svg" type="image/webp">
                      <img src="/static/img/accordeon/link.svg" alt="" />
                    </picture>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="info">
      <div class='container'>
        <div class="info__wrapper">
          <div class="info__up">
            <div class="info__black black-info">
              <h2 class="black-info__title">Как и почему с нашими документами выигрываются дела?</h2>
              <p class="black-info__text">Вы не знаете законов, не знаете своих прав, не знаете какие юридические ошибки могут быть совершены.
                Поэтому мы все уже сделали за вас и сделали это правильно!
                Главное - это не то, что говорите в суде, а доказательства.
                У нас обобщено 22340 дел на 1 квартал 2020 года и каждый день в базу добавляются новые дела.</p>
            </div>
            <div class="info__white white-info">
              <h2 class="white-info__title">299 руб за все документы для того, чтобы вы выиграли свое дело. Плюс, пошаговая инструкция: как выиграть дело до суда или в суде.</h2>
              <ol class="white-info__list">
                <li>Никаких сомнительных юристов, берущих деньги за «воздух»</li>
                <li>Проверенные, актуальные на сегодняшний день решения из всех областей автомобильного права</li>
                <li>Сотни автовладельцев ежедневно решают свои проблемы при помощи нашего сервиса и рекомендуют нас своим друзьям и знакомым</li>
              </ol>
              <div class="white-info__btn">
                <button><span>Получить документы</span></button>
              </div>
            </div>
          </div>
          <div class="info__down">
            <h1 class="info__down-title">Примеры дел, выигранных с нами</h1>
            <div class="info__content content-info">
              <div class="content-info__items items-info">
                <div class="items-info__up">
                            <span class="items-info__img">
                                <picture>
                                    <source srcset="/static/img/info/1.webp" type="image/webp">
                                    <img src="/static/img/info/1.jpg" alt="Фото" />
                                </picture>
                            </span>
                  <div class="items-info__text items-info__text--green"><p>История Алексея</p></div>
                </div>
                <div class="items-info__down">
                  <p>Алексей заплатил автоюристам 8000 рублей за подготовку документов, а в суд решил пойти сам. Алексей разобрался со всеми нюансами, все изучил. Но решил проверить качество работы своего юриста. Он нашел наш сайт и купил за 299 рублей пакет документов по возврату прав – это смешная сумма, когда решается такой важный вопрос. Алексей не просто проверил качество работы своего юриста, он увидел, что эти юристы работают по тем самым шаблонам, которые он купил за 299 рублей. Алексей в итоге дело выиграл, но переплатил за ненужные услуги.</p>
                </div>

              </div>
              <div class="content-info__items items-info">
                <div class="items-info__up">
                  <span class="items-info__img"><picture><source srcset="/static/img/info/2.webp" type="image/webp"><img src="/static/img/info/2.jpg" alt="Фото" /></picture></span>
                  <div class="items-info__text items-info__text--red"><p>История транспортной компании</p></div>
                </div>
                <div class="items-info__down">
                  <p>Иван – представитель автопредприятия и для своих сотрудников он купил весь комплект образцов жалоб и заявлений программы «АнтиАвтоюрист». Все больше и больше тех, кто связан с автобизнесом становятся клиентами «АнтиАвтоюрист» потому что это эффективно. Не нужно быть юристом и не нужно платить деньги юристам чтобы выиграть свое дело.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="for-whom">
      <div class='container'>
        <div class="for-whom__wrapper">
          <h1 class="for-whom__title">Для кого</h1>
          <ul class="for-whom__list">
            <li>Для тех, кому предстоит суд по любому автомобильному вопросу</li>
            <li>Для тех, кто хочет решить вопрос в досудебном порядке</li>
            <li>Для тех, кто сомневается в качестве работы своего юриста или просто хочет проверить его работу</li>
            <li>Для начинающих юристов, помощников юристов и студентов</li>
          </ul>
          <div class="for-whom__form form-whom">
            <div class="form-whom__wrapper">
              <div class="form-whom__input" style="flex: 0 1 100%;margin-right: 0;">
                <div :class="selectGroup.show?'nice-select select-block open':'nice-select select-block'" @click="selectGroup.show=1" @focusout="selectGroup.show=0" tabindex="0">
                  <span class="current">{{selectGroup.name}}</span>
                  <ul class="list">
                    <li v-for="group in groups" :key="group.id" :class="selectGroup.id===group.id?'option selected focus':'option'" @click="selectGroup.id = group.id, selectGroup.name = group.name">
                      {{group.name}}</li>
                  </ul>
                </div>
              </div>
              <div class="form-whom__input" style="flex: 0 1 100%;margin-right: 0;" v-show="parseInt(selectGroup.id)">
                <div :class="selectService.show?'nice-select select-block open':'nice-select select-block'" @click="selectService.show=1" @focusout="selectService.show=0" tabindex="0">
                  <span class="current">{{selectService.name}}</span>
                  <ul class="list">
                    <li v-for="service in services" :key="service.id" :class="selectService.id===service.id?'option selected focus':'option'"  v-if="parseInt(service.cf[341]) === parseInt(selectGroup.id)" @click="selectService.id = service.id, selectService.name = service.cf[403]">
                      {{service.cf[403]}}</li>
                  </ul>
                </div>
              </div>
              <div class="form-whom__input">
                <input autocomplete="off" type="text" class="input" placeholder="Город" v-model="city"/>
              </div>
              <div class="form-whom__input">
                <input autocomplete="off" type="text" class="input" placeholder="Имя" v-model="name"/>
              </div>
              <div class="form-whom__input">
                <input autocomplete="off" type="tel" class="input" placeholder="Телефон" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" />
              </div>

              <div class="form-whom__input">
                <input autocomplete="off" type="email" class="input" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
              </div>
              <div class="form-whom__btn-wrapper">
                <button class="form-whom__btn" @click="sendQuestion"><span>Получить документы по моему делу</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '@/router/http'
import Inputmask from 'inputmask'
export default {
  name: 'HelloWorld',
  data () {
    return {
      groups: [],
      services: [],
      selectGroup: {id: null, show: 0, name: null},
      selectService: {id: null, show: 0, name: null},
      name: null,
      email: null,
      phone: null,
      city: null
    }
  },
  mounted () {
    Inputmask().mask(document.querySelectorAll('input'))
    setTimeout(() => {
      Inputmask().mask(document.querySelectorAll('input'))
    }, 1000)
    axios.get('https://urist1.v-avtoservice.com/list/get-lists?id=31').then(response => {
      this.groups = response.data
    })
    axios.get('https://urist1.v-avtoservice.com/list/get-lists?id=32').then(response => {
      this.services = response.data
    })
    $(document).on('click', '.item-accordion__header', function () {
      var parent = $(this).parent()
      if (parent.hasClass('active')) {
        parent.removeClass('active')
      } else {
        $('.accordion__item').removeClass('active')
        parent.addClass('active')
      }
    })
  },
  methods: {
    showModal () {
      this.$root.requestModal = 1
    },
    sendQuestion () {
      if (!this.email) alert('Вам необходимо указать E-mail')
      else {
        var formData = new FormData()
        formData.append('crm', '9')
        formData.append('pipe', '17')
        formData.append('contact[name]', this.name)
        formData.append('contact[141]', this.phone)
        formData.append('contact[142]', this.email)
        formData.append('contact[143]', this.city)
        formData.append('lead[147]', this.city)
        formData.append('lead[404]', this.selectGroup.name)
        formData.append('lead[145]', this.selectService.name)
        axios.post('https://urist1.v-avtoservice.com/api/import-lead',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        setTimeout(() => { alert('Спасибо, ваша заявка отправлена') }, 1)
      }
    }
  },
  watch: {
    'selectGroup.id' (val, oldVal) {
      if (val !== oldVal) {
        setTimeout(() => {
          this.selectGroup.show = 0
        }, 100)
      }
    },
    'selectService.id' (val, oldVal) {
      if (val !== oldVal) {
        setTimeout(() => {
          this.selectService.show = 0
        }, 100)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue